import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=0f59d61d&scoped=true"
import script from "./dataForm.vue?vue&type=script&lang=js"
export * from "./dataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f59d61d",
  null
  
)

export default component.exports